import { tracked } from "@glimmer/tracking";
import Controller from "@ember/controller";
import { action } from "@ember/object";
import { ajax } from "discourse/lib/ajax";
import { popupAjaxError } from "discourse/lib/ajax-error";
import getURL from "discourse/lib/get-url";

export default class AdminPluginsShowCommunityNavigationStructureController extends Controller {
  @tracked structure;
  @tracked initializing = false;
  @tracked mappingKey;
  chatSettingsUrl = getURL(
    "/admin/site_settings/category/all_results?filter=chat_enabled"
  );

  get initializeDisabled() {
    return (
      !this.structure.chat_enabled ||
      this.structure.installation_upgrade.blocked ||
      this.structure.slots.some((slot) => slot.status === "conflict")
    );
  }

  @action
  async initializeStructure() {
    this.initializing = true;
    try {
      this.structure = await ajax(
        "/admin/plugins/community-navigation/initialize.json",
        {
          type: "POST",
        }
      );
      window.location.assign(
        getURL("/admin/plugins/discourse-community-navigation")
      );
    } catch (error) {
      popupAjaxError(error);
    } finally {
      this.initializing = false;
    }
  }

  @action
  async updateMapping(key, { entityId }) {
    this.mappingKey = key;
    try {
      this.structure = await ajax(
        `/admin/plugins/community-navigation/mappings/${key}`,
        {
          type: "PUT",
          data: { entity_id: entityId },
        }
      );
    } catch (error) {
      popupAjaxError(error);
    } finally {
      this.mappingKey = null;
    }
  }
}
